import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {DisposeBag} from "../../modules/DisposeBag";
import {DebounceFactory} from "../../modules/DebounceModule";
import {CustomerTagGroupDto} from "../../model/CustomerTagGroupDto";
import {IFormController} from "angular";
import {CustomerTagDto} from "../../model/CustomerTagDto";
import {Guid} from "guid-typescript";

export default class TagsController implements Ng1Controller {
    private disposeBag = new DisposeBag();
    private tagGroups: CustomerTagGroupDto[];

    $onInit(): void {
        this.refreshDebounce();
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        this.disposeBag.finalize();
        return undefined;
    }


    constructor(private $dataHub: DataHubService,
                private $debounce: DebounceFactory,
                private $state: StateService, private $stateParams: any) {
        this.$dataHub.bindAllCustomerTagGroup(() => this.tagGroups, this.disposeBag);
        $dataHub.onConnected(this.refreshDebounce, this.disposeBag);
    }

    refreshDebounce = this.$debounce(() => this.refresh(), 500, false);

    refresh = () => {
        console.debug('refresh', this.$dataHub.isConnected)
        if (!this.$dataHub.isConnected) return;

        this.$dataHub.customerTagGroupSubscribeAndQuery()
            .then(ret => this.tagGroups = ret)
            .catch(this.$dataHub.defaultErrorHandler);
    };

    save = (group: CustomerTagGroupDto, form: IFormController) => {
        this.$dataHub.customerTagGroupUpdate(group)
            .then(() => {
                form?.$setPristine();
            })
            .catch(this.$dataHub.defaultErrorHandler);
    }

    addGroup = () => {
        let group = new CustomerTagGroupDto();
        group.guid = Guid.create();
        this.tagGroups.push(new CustomerTagGroupDto());
    }

    addTag = (group: CustomerTagGroupDto) => {
        if (group["newTagName"]) {
            let tag = new CustomerTagDto();
            tag.name = group["newTagName"];
            group.tags.push(tag);
            group["newTagName"] = null;
        }
    }


}
